import React from "react";
import Skill from "./Skill";

const Languages = () => {
    return <div className="cv__langages pt-5">
        <h4>Langues</h4>
        <div className="cv__technologie-content pt-3 ps-2 pe-2">
            <Skill title="Francais" level={80} />
            <Skill title="Anglais" level={35} />
        </div>
    </div>
}

export default Languages